import { render, staticRenderFns } from "./sellerIntroduction.vue?vue&type=template&id=21f9079e"
import script from "./sellerIntroduction.vue?vue&type=script&lang=js"
export * from "./sellerIntroduction.vue?vue&type=script&lang=js"
import style0 from "./sellerIntroduction.vue?vue&type=style&index=0&id=21f9079e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports